<script>
// This component loads data for internet wait time (IWT), merges and transforms it, then updates the Vuex store.

  // Component loads
  // Waits for Office Locations App data to load
  // Waits for Office Locs + IWT Key JSON to load
  // Loads IWT data
  // Merges the two data sources by key
  // Updates Vue state

// This renders nothing on the screen.

// All this should be in a web worker

import { useRootStore } from "../store";
import { toRaw } from "vue";

/*eslint no-useless-escape: */
/*eslint no-redeclare: */
export default {
  name: "InternetWaitTimeLoader",
  data() {
    return {
      rootStore: useRootStore(),
      IWTdataDL:"",
      IWTdataLPA:"",
      IWTdataIRP:"",
      IWTdataLT:"",
      loadIWTFlag: false,
      IWTdataLoadedDL: false,
      IWTdataLoadedLPA: false,
      // IWTdataLoadedIRP: false,
      // IWTdataLoadedLT: false,

      // Have the Office Locations app locations loaded?
      officeLocsDLloaded:false,
      officeLocsDLKioskLoaded:false,
      officeLocsLPAloaded:false,
      officeLocsLPAKioskLoaded:false,
      // officeLocsIRPloaded:false,
      // officeLocsLTloaded:false,

      // Have the IWT office keys loaded?
      officeKeysDLloaded: false, 
      officeKeysLPAloaded: false, 
      // officeKeysMOloaded: false, 
      // officeKeysIRPloaded: false, 
      // officeKeysLTloaded: false,

      // Temporary table that connects NCDMV and IWT locations
      officeKeysDL: [], 
      officeKeysLPA: [], 
      // officeKeysMO: [], 
      // officeKeysIRP: [], 
      // officeKeysLT: []
    };
  },


created(){
   
    // Load the keys that match DMV Office Locs with IWT locs
    console.log("PROGRESS: Internet Wait Time component mounted")

    this.loadITWtimeKeys()

      // now.toLocaleTimeString('en-US',{timeZone:'America/New_York'})

      // Get the current date
      // this.loadIWTFlag = true;
    
},
watch: {
    getallowedDateTime:function() {
      if(this.getallowedDateTime && this.getallowedDateTime.enableWaitTimesFeature){
       return this.loadIWTFlag = true;
      }
    },
    // Add a flag for when office locations data has loaded
    // Need that fully loaded before trying to mix in IWT data
    getOfficeDL:function(){
      if(this.getOfficeDL.length > 50){     
        return this.officeLocsDLloaded = true
      }
    },
    getOfficeDLkiosk:function(){
      if(this.getOfficeDL.length > 50){     
        return this.officeLocsDLKioskLoaded = true
      }
    },
    getOfficeLPA:function(){
      if(this.getOfficeLPA.length > 50){
        return this.officeLocsLPAloaded = true
      }
    },
    getOfficeLPAkiosk:function(){
      if(this.getOfficeLPA.length > 50){
        return this.officeLocsLPAKioskLoaded = true
      }
    },
    // getOfficeLT:function(){
    //   if(this.getOfficeLT.length > 1){
    //     return this.officeLocsLTloaded = true
    //   }
    // },
    // getOfficeIRP:function(){
    //   if(this.getOfficeIRP.length > 1){
    //     return this.officeLocsIRPloaded = true
    //   }
    // },

    // Error appears to be here. Watcher goes true, then false and doesn't load
    // When office location data is loaded, start the IWT web service loading
    officeLocsDLloaded:function(){
      // Only merge IWTOffice keys for DL/license data
      if (this.officeKeysDLloaded) {
        console.log("PROGRESS: NCDMV Office location data is loaded, merging IWTOffice keys for DL only");
        this.mergeIWTkeysWithNCDMV(this.getOfficeDL, this.officeKeysDL, "SET_OFFICE_DL");
      }
    },


  // These bothsides watchers listen for when both IWT and DMV office data is loaded, and then starts the merging process
  // bothSidesLoadedDL is not needed if you only want to merge keys and not IWT data

  // bothSidesLoadedLPA is not needed if you only want to merge keys and not IWT data
    loadIWTFlag() {
      
      const allowedDateTimeObj = this.getallowedDateTime;
      const iwtWindowCheck = () => {
        let now = new Date();
        let nowAdjusted = new Date(now.toLocaleString('en-US', { timeZone: 'America/New_York' }))
        let day = nowAdjusted.getDay()
        let hours = nowAdjusted.getHours()
        console.log("TIME: The user's browser time is " + now + " and we've converted it to " + nowAdjusted + ". The numerical day of the week is " + day + ", and the hour is " + hours + ".")
        if ((day === allowedDateTimeObj.endDate) || (day > allowedDateTimeObj.startDate && day < allowedDateTimeObj.endDate && hours >= allowedDateTimeObj.startTime)) {
          console.log("RULE SETTING: Since it is after noon on a weekday, or a Saturday, we can display Internet Wait Time")
          this.rootStore.SET_IWTLOADWINDOW(true)
          return true;
        } else {
          console.log("RULE SETTING: It is before noon on a weekday or a Sunday, so we don't load Internet Wait Time")
          this.rootStore.SET_IWTLOADWINDOW(false)
          return false;
        }
      }
      iwtWindowCheck();
      // No polling or IWT data fetching needed for key-only merge
      // If you need to periodically update the primary card or merge keys, add logic here
      // Otherwise, this watcher now only sets the IWTLOADWINDOW flag

    }
    // bothSidesLoadedMO:function(){
    //     if(this.bothSidesLoadedMO !== undefined && this.bothSidesLoadedMO === true){
    //         console.log("PROGRESS: Starting to merge MO Office location data with IWT data")
    //         return this.mergeIWTkeysWithNCDMV(this.getOfficeMO,this.officeKeysLPA,"SET_OFFICEMO",this.IWTdataMO)
    //     }        
    // },

    // bothSidesLoadedIRP:function(){
    //     if(this.bothSidesLoadedIRP !== undefined && this.bothSidesLoadedIRP === true){
    //         console.log("PROGRESS: Starting to merge DL Office location data with IRP data")
    //         return this.mergeIWTkeysWithNCDMV(this.getOfficeIRP,this.officeKeysLPA,"SET_OFFICEIRP",this.IWTdataIRP)
    //     }        
    // },

    // bothSidesLoadedLT:function(){
    //     if(this.bothSidesLoadedLT !== undefined && this.bothSidesLoadedLT === true){
    //         console.log("PROGRESS: Starting to merge DL Office location data with LT data")
    //         return this.mergeIWTkeysWithNCDMV(this.getOfficeLT,this.officeKeysLPA,"SET_OFFICELT",this.IWTdataLT)
    //     }        
    // },
  },
  methods: {
    updatePrimaryCard() {
      let currentMarker = this.rootStore.primaryCard;
            if(currentMarker?.IWTOffice) {
              let newWaitTime = this.IWTdataDL.find(item => item.IWTOffice === currentMarker?.IWTOffice);
              currentMarker.IWTavgWT = newWaitTime.IWTavgWT;
              this.rootStore.SET_PRIMARY_CARD(currentMarker);
            }
    },
  // loadIWTPolling is not needed if you are not fetching IWT data
    
    // Loads IWT keys, a JSON/.data file that is used to
    // match up IWT's offices with DMV Office Locations app
    // locations. 
    
    // Once loaded, state is updated and a flag
    // is set to true.
    loadITWtimeKeys() {
      console.log("PROGRESS: Starting to load IWT keys")
      // To do:  These four should be a single function. Stuck right now because we're
      // fetching environmental variables.
      fetch(process.env.VUE_APP_OFFICEMATCHDL)
        .then((response) => response.json())
        .then((data) => {
            return [this.officeKeysDL = data, this.officeKeysDLloaded = true]
        }).catch((error) => {
            return console.error('Error loading matching key for ' + process.env.VUE_APP_OFFICEMATCHDL + ':\n', error);
        });

      fetch(process.env.VUE_APP_OFFICEMATCHLPA)
        .then((response) => response.json())
        .then((data) => {
            return [this.officeKeysLPA = data, this.officeKeysLPAloaded = true]
        }).catch((error) => {
            return console.error('Error loading matching key for  ' + process.env.VUE_APP_OFFICEMATCHDL + ':\n', error);
        });

      // fetch(process.env.VUE_APP_OFFICEMATCHMO)
      //   .then((response) => response.json())
      //   .then((data) => {
      //       return [this.officeKeysMO = data, this.officeKeysMOloaded = true]
      //   }).catch((error) => {
      //       return console.error('Error loading matching key for  ' + process.env.VUE_APP_OFFICEMATCHDL + ':\n', error);
      //   });

      fetch(process.env.VUE_APP_OFFICEMATCHLT)
        .then((response) => response.json())
        .then((data) => {
            return [this.officeKeysLT = data, this.officeKeysLTloaded = true]
        }).catch((error) => {
            return console.error('Error loading matching key for  ' + process.env.VUE_APP_OFFICEMATCHDL + ':\n', error);
        });

      fetch(process.env.VUE_APP_OFFICEMATCHIRP)
        .then((response) => response.json())
        .then((data) => {
            return [this.officeKeysIRP = data, this.officeKeysIRPloaded = true]
        }).catch((error) => {
            return console.error('Error loading matching key for  ' + process.env.VUE_APP_OFFICEMATCHDL + ':\n', error);
        });
    },


  // Returns a "red, yellow, green" status for each office
    buildIWTwaitLevel(passedTime){

          const timeArray = passedTime.split(":")

          // Handle 1 to 2 hours
          if(timeArray[0] === '1' && timeArray[1] !== '00' ){
            return "yellow"
          }

          // Handle greater than two hours
          if(timeArray[0] !== '0' && timeArray[0] !== '1'){
            return "red"
          }

          // Under an hour makes you green
          return "green"

    },


    // IWT teturns a response of "0:00:00" to, this function returns
    // a more human readable syntax for display
    buildTimeString(passedTime){       

        // Break the default returned time into an array
        const timeArray = passedTime.split(":")

        // Numbers are strings here. 

        // Handle exactly zero hours, zero minutes, aka "excellent timing on the customer's part" 
        if(timeArray[0] === '0' && timeArray[1] === '00' ){  
          return "0 minutes"
        }

        // Handle exactly 1 minute
        if(timeArray[0] === '0' && timeArray[1] === '01' ){  
          return parseInt(timeArray[1]) + " minute"
        }

        // Handle exactly 1 hour no minutes
        if(timeArray[0] === '1' && timeArray[1] === '00' ){
            return "1 hour"
        }

        // Handle 1 hour and some minutes
        if(timeArray[0] === '1' && timeArray[1] !== '00' ){
          return "1 hour, " + timeArray[1] + " minutes"
        }

        // Handle "some number of minutes and zero hours"
        if(timeArray[0] === '0' && timeArray[1] !== '00' ){  
          return parseInt(timeArray[1]) + " minutes"
        }

        // Handle >1 hours, no minutes
        if(timeArray[0] !== '1' && timeArray[0] !== '0' && timeArray[1] === '00' ){
            return timeArray[0] + " hours"
        }

        // Handle some combination of hours and exactly 1 minute
        if(timeArray[0] !== '0' && timeArray[1] === '01' ){
          return timeArray[0] + " hours, " + parseInt(timeArray[1]) + " minute"
        }
        
        // Handle some combination of hours and minutes (The most common scenario)
        if(timeArray[0] !== '0' && timeArray[1] !== '00' ){
            return timeArray[0] + " hours, " + parseInt(timeArray[1]) + " minutes"
        }


        return ""
    },

    // Loads IWT times from ACF product.
    // Expects the top level unit from computed properties, 
    // and then the two letter code for the type office
   async loadIWTdata(iwtType,ncdmvType) {
      if(iwtType !== undefined && iwtType !==null && iwtType !==""){

        console.log("loadIWTdata is starting for " + ncdmvType )
      // rootStore-iwtURL Returns this tier's IWT REST API URL
       await fetch(this.rootStore.iwtURL + iwtType)
          .then((response) => response.text())
          .then((data) => {
            
            console.log("PROGRESS: Starting to load IWT data for " + ncdmvType)

            // Convert ACF's IWT data into XML, since that's what
            // its being sent as.
            const parser = new DOMParser();
            const xml = parser.parseFromString(data, "application/xml");

            // Convert the XML to JSON
            let returnedJSON = this.xmlToJson(xml)

            // Just the Unit level 
            let unitReturnedJson = returnedJSON.Units.Unit

            // Handle edge case. If there's only 1 location retunred, unitReturnedJson 
            // comes back as an object instead of an array of objects.
            const checkArray = Array.isArray(unitReturnedJson)

            if(checkArray === false){
              console.log('Note: Only 1 location returned for office type ' + ncdmvType)
              const tempArray = []
              tempArray.push(unitReturnedJson)
              unitReturnedJson = tempArray
            }
        
            // Clean up some oddly-structured nested objects
            for (const i of unitReturnedJson){
              i.ParentUnitName = i.ParentUnitName["#text"]
              i.ParentUnitId = parseInt(i.ParentUnitId["#text"])
              i.IWTOffice = parseInt(i["@attributes"]["UnitId"])
              delete i["@attributes"]
              delete i.Description
              delete i.OfficePhone
              i.IWTaddress = i.Address["#text"]
              delete i.Address
              i.IWThours = i.OfficeHours["#text"]
              delete i.OfficeHours
              i.IWTstatus = i.OfficeStatus["#text"]
              delete i.OfficeStatus
              i.IWTunitlevel = i.UnitLevel["#text"]
              delete i.UnitLevel
              i.IWTunitName = i.UnitName["#text"]
              delete i.UnitName
              i.IWTparentUnitId = i.ParentUnitId
              delete i.ParentUnitId
              i.IWTparentUnitName = i.ParentUnitName
              delete i.ParentUnitName
              i.IWTMaxWT = i.MaxWT["#text"]
              delete i.MaxWT
              i.IWTavgWT = i.AvgWT["#text"]
              delete i.AvgWT   

              // Add a green, yellow, red 3 tier alert system
              i.IWTwaitLevel = this.buildIWTwaitLevel(i.IWTavgWT)

              // Convert average wait time to human-readable
              i.IWTavgWToriginal = i.IWTavgWT  // The generated time before transforming it
              i.IWTavgWT = this.buildTimeString(i.IWTavgWT)
            }

            // Data is now fully loaded for each office. Time to
            // assign that data to component state, and set the loaded
            // flag to true.
            if(ncdmvType === "DL"){
              return [
                this.IWTdataDL = unitReturnedJson,
                this.IWTdataLoadedDL = true,
                console.log("PROGRESS: Store now knows IWT data is loaded"),
                this.rootStore.SET_ISIWTLOADED(true)
                ]
            } else if(ncdmvType === "LPA"){
              return [
                this.IWTdataLPA = unitReturnedJson,
                this.IWTdataLoadedLPA = true
                ]
            // } else if(ncdmvType === "IRP"){
            //   return [
            //     this.IWTdataIRP = unitReturnedJson,
            //     this.IWTdataLoadedIRP = true
            //     ]
            // } else if(ncdmvType === "LT") {
            //     return [
            //       this.IWTdataLT = unitReturnedJson,
            //       this.IWTdataLoadedLT = true
            //     ]
            } else{
              return false
            }
        }).catch((error) => {
            return [
              console.error('Unable to load Internet Wait Time from ' + process.env.VUE_APP_LOCATIONS_IWT_URL),
              console.error('The Internet Wait Time webservice error is ' + error)
            ];
        });

      } else{
        return false
      }
    },
   
   // Merges IWT keys (just the keys) loaded NCDMV Office Locations app data.
   mergeIWTkeysWithNCDMV(officeStore, iwtOfficeKeys, storeToUpdate) {
      // Only merge IWTOffice keys, do not merge IWT API data
      let mergeById = (a1, a2) =>
        a1.map(itm => ({
          ...a2.find((item) => (item.id === itm.id) && item),
          ...itm
        }));

      const mergedIDs = mergeById(toRaw(officeStore), toRaw(iwtOfficeKeys));
      console.log("PROGRESS: Merged IWTOffice keys with NCDMV Office Locs data for " + storeToUpdate);
      return this.rootStore[storeToUpdate] ? this.rootStore[storeToUpdate](mergedIDs) : null;
    },
    
    // Merge keyed DMV Office Data with now loaded IWT times. 
    // Updates Vuex state with results
  // mergeIWTdatawithNCDMV is not needed if you are not merging IWT API data

    // Helper funciton to convert IWT's XML data to JSON
    xmlToJson(xml) {
      var obj = {};

      if (xml.nodeType == 1) {
        // element
        // do attributes
        if (xml.attributes.length > 0) {
          obj["@attributes"] = {};
          for (var j = 0; j < xml.attributes.length; j++) {
            var attribute = xml.attributes.item(j);
            obj["@attributes"][attribute.nodeName] = attribute.nodeValue;
          }
        }
      } else if (xml.nodeType == 3) {
        // text
        obj = xml.nodeValue;
      }

      // elements children
      if (xml.hasChildNodes()) {
        for (var i = 0; i < xml.childNodes.length; i++) {
          var item = xml.childNodes.item(i);
          var nodeName = item.nodeName;
          if (typeof obj[nodeName] == "undefined") {
            obj[nodeName] = this.xmlToJson(item);
          } else {
            if (typeof obj[nodeName].push == "undefined") {
              var old = obj[nodeName];
              obj[nodeName] = [];
              obj[nodeName].push(old);
            }
            obj[nodeName].push(this.xmlToJson(item));
          }
        }
      }
      return obj;
    },
  },
  computed: {
      // Fires when:
        // IWT data is loaded
        // All offices for this type are loaded
        // The IWT matching keys are loaded
    bothSidesLoadedDL(){ 

        if(this.IWTdataLoadedDL === true && this.rootStore.officeDL.length > 0 && this.officeKeysDLloaded === true){
        // if(this.officeKeysDLloaded === true && ){
          return true
        } else 
            return false
    },

    bothSidesLoadedLPA(){ 
        if(this.IWTdataLoadedLPA === true && this.rootStore.officeLPA.length > 0 && this.officeKeysLPAloaded === true){
                return true
            } else 
        return false
    },

    // bothSidesLoadedMO(){
    //      if(this.IWTdataLoadedMO === true && this.rootStore.officeMO.length > 0 && this.officeKeysMOloaded === true){
    //         return true
    //     } else 
    //         return false
    // },

    // bothSidesLoadedIRP(){
    //     if(this.IWTdataLoadedIRP === true && this.rootStore.officeIRP.length > 0 && this.officeKeysIRPloaded === true){
    //         return true
    //     } else 
    //         return false
    // },

    // bothSidesLoadedLT(){
    //     if(this.IWTdataLoadedLT === true && this.rootStore.officeLT.length > 0 && this.officeKeysLTloaded === true){
    //         return true
    //     } else 
    //         return false
    // },

    // Returns office locations loaded data
    getOfficeDL() { 
      console.log("PROGRESS: getOfficeDL exists in Vuex")
      return this.rootStore.officeDL;
    },

    getOfficeDLkiosk() {  
      return this.rootStore.officekDLwithKiosks;
    },

    // DL Saturday offices
    getOfficeDLSaturday(){
      return this.rootStore.officeDLSaturday
    },

    getOfficeLPA() { 
      return this.rootStore.officeLPA;
    },

    getOfficeLPAkiosk() { 
      return this.rootStore.officeLPAwithKiosks;
    },
 
    getallowedDateTime() { 
      return this.rootStore.allowedDateTime;
    },
    
    // getOfficeMO() {
    //   return this.rootStore.officeMO;
    // },
    // getOfficeIRP() {
    //   return this.rootStore.officeIRP;
    // },
    // getOfficeLT() {
    //   return this.rootStore.officeLT;
    // },

    // Top level unit IDs for each type of IWT office
    // getIWTTopLevelUnitDL() {
    //   return this.rootStore.itwTopLevelUnitDL
    // },
    // getIWTTopLevelUnitLPA() {
    //   return this.rootStore.itwTopLevelUnitLPA
    // },


    // getIWTTopLevelUnitIRP() {
    //   return this.rootStore.itwTopLevelUnitIRP
    // },
    // getIWTTopLevelUnitLT() {
    //   return this.rootStore.itwTopLevelUnitLT
    // }
  }
}
</script>